import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import BecomeDistributor from "@/pages/BecomeDistributor";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import WarrantyRegistration from "@/pages/WarrantyRegistration";
import Policies from "@/pages/Policies";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminOrders from "@/pages/AdminOrders";
import DataCableManufacturer from "@/pages/DataCableManufacturer";
import MobileChargerManufacturer from "@/pages/MobileChargerManufacturer";
import OemManufacturer from "@/pages/OemManufacturer";
import BestDataCableFactory from "@/pages/BestDataCableFactory";
import BestDataCableFactoryDelhi from "@/pages/BestDataCableFactoryDelhi";
import BestDataCableManufacturerIndia from "@/pages/BestDataCableManufacturerIndia";
import PremiumChargerManufacturerIndia from "@/pages/PremiumChargerManufacturerIndia";
import MobileAccessoriesManufacturerIndia from "@/pages/MobileAccessoriesManufacturerIndia";
import OemChargerManufacturerNoida from "@/pages/OemChargerManufacturerNoida";
import FastChargingCableManufacturer from "@/pages/FastChargingCableManufacturer";
import FAQHub from "@/pages/FAQHub";
import FAQDataCables from "@/pages/FAQDataCables";
import FAQMobileChargers from "@/pages/FAQMobileChargers";
import FAQManufacturing from "@/pages/FAQManufacturing";
import QualityCertifications from "@/pages/QualityCertifications";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

// Remove third-party branding
function removeBranding() {
  const badge = document.getElementById('emergent-badge');
  if (badge && badge.parentNode) {
    badge.parentNode.removeChild(badge);
  }
  document.querySelectorAll('a[href*="emergent"]').forEach(el => {
    if (el.parentNode) el.parentNode.removeChild(el);
  });
}

function App() {
  useEffect(() => {
    // Remove branding on mount and set up observer
    removeBranding();
    
    const observer = new MutationObserver(() => {
      removeBranding();
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also run periodically as backup
    const interval = setInterval(removeBranding, 1000);
    
    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App min-h-screen flex flex-col">
        {/* Fixed Header - Always visible on scroll */}
        <header className="fixed top-0 left-0 right-0 z-50">
          <Navbar />
        </header>
        {/* Spacer to prevent content from hiding behind fixed header */}
        <div className="h-[28px] md:h-[28px]"></div>
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:category" element={<Shop />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/become-distributor" element={<BecomeDistributor />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/warranty-registration" element={<WarrantyRegistration />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/terms-of-service" element={<Policies />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/data-cable-manufacturer-in-noida" element={<DataCableManufacturer />} />
            <Route path="/best-mobile-charger-manufacturer-in-noida" element={<MobileChargerManufacturer />} />
            <Route path="/oem-mobile-accessories-manufacturer-in-india" element={<OemManufacturer />} />
            <Route path="/best-data-cable-factory-in-noida" element={<BestDataCableFactory />} />
            <Route path="/best-data-cable-factory-in-delhi" element={<BestDataCableFactoryDelhi />} />
            <Route path="/best-data-cable-manufacturer-india" element={<BestDataCableManufacturerIndia />} />
            <Route path="/premium-charger-manufacturer-india" element={<PremiumChargerManufacturerIndia />} />
            <Route path="/mobile-accessories-manufacturer-india" element={<MobileAccessoriesManufacturerIndia />} />
            <Route path="/oem-charger-manufacturer-noida" element={<OemChargerManufacturerNoida />} />
            <Route path="/fast-charging-cable-manufacturer" element={<FastChargingCableManufacturer />} />
            <Route path="/faq" element={<FAQHub />} />
            <Route path="/faq/data-cables" element={<FAQDataCables />} />
            <Route path="/faq/mobile-chargers" element={<FAQMobileChargers />} />
            <Route path="/faq/manufacturing" element={<FAQManufacturing />} />
            <Route path="/quality-certifications" element={<QualityCertifications />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;